import React, { useEffect } from "react";
import { Container, Button, Card } from "react-bootstrap";
import {
	createRider,
	deleteJuniorRiders,
	getRiders,
	toggleRiderStatus,
	updateRidersFromFile,
} from "../../services/riderService";
import { getSeries, getSports } from "../../services/series";
import CreateRiderForm from "./components/riderComponents/CreateRiderForm";
import RiderList from "./components/riderComponents/RiderList";
import { initialRider } from "../../types/model";
import AdminLayout from "./AdminLayout";

const AdminRidersPage = () => {
	const [riders, setRiders] = React.useState([]);
	const [selectedRider, setSelectedRider] = React.useState(null);
	const [sports, setSports] = React.useState([]);
	const [series, setSeries] = React.useState([]);
	const [formData, setFormData] = React.useState({
		initialRider,
	});

	useEffect(() => {
		fetchRiders();
		fetchSports();
		fetchSeries();
	}, []);

	const fetchRiders = async () => {
		// Fetch all riders
		try {
			const res = await getRiders();

			if (res) {
				setRiders(res.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const fetchSports = async () => {
		try {
			const res = await getSports();
			if (res) {
				setSports(res.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const fetchSeries = async () => {
		try {
			const res = await getSeries();
			if (res) {
				setSeries(res.data);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const riderData = {
			...formData,
			sports: formData.selectedSports,
			series: formData.selectedSeries,
		};

		try {
			const res = await createRider(riderData);
			if (res.status === 201) {
				fetchRiders();
			}
		} catch (error) {
			alert("Error creating rider:" + error);
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value,
		});
	};

	const handleUpdateRidersFromFile = async () => {
		try {
			const res = await updateRidersFromFile();

			if (res.status === 200) {
				alert("Riders updated successfully");
				fetchRiders();
			}
		} catch (error) {
			alert("Error updating riders from file:" + error);
		}
	};

	const handleDeleteJuniorRiders = async () => {
		try {
			const res = await deleteJuniorRiders();
			if (res.status === 200) {
				alert("Junior riders deleted successfully");
				fetchRiders();
			}
		} catch (error) {
			alert("Error deleting junior riders:" + error);
		}
	};

	const handleToggleRider = async (rider) => {
		// Toggle the status of the rider
		try {
			const res = await toggleRiderStatus(rider._id);
			if (res.status === 200) {
				console.log("Status toggled successfully");

				fetchRiders();
				//Update the rider list
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleSportAndSeriesChange = (e) => {
		const { name, value, options } = e.target;

		const selectedValues = Array.from(options)
			.filter((option) => option.selected)
			.map((option) => option.value);

		setFormData({
			...formData,
			[name]: selectedValues,
		});

		console.log(formData);
	};

	const handleRatingChange = (e) => {
		const { name, value } = e.target;
		const sportId = name.split("-")[1];
		setFormData({
			...formData,
			ratings: [
				...formData.ratings.filter((rating) => rating.sport !== sportId),
				{
					sport: sportId,
					rating: value,
				},
			],
		});
	};

	return (
		<AdminLayout>
			<Container className="p-4">
				<RiderList
					riders={riders}
					setRider={setSelectedRider}
					toggleRider={handleToggleRider}
					sports={sports}
					series={series}
					fetchRiders={fetchRiders}
				/>
				<CreateRiderForm
					riderData={selectedRider}
					setSelectedRider={setSelectedRider}
					fetchRiders={fetchRiders}
				/>
				<Card className="mt-4">
					<Card.Body>
						<Card.Title>Update Riders from UCI File</Card.Title>
						<Card.Text>
							<p>
								This will parse out riders from
								server/Riders/riders_complete_2025.json.
							</p>
							<p>
								1. This will add any new DH riders found to the list (matched on
								name, series and sport)
							</p>
							<p>
								- New riders will have gender as 'tbd' and status as 'active' and
								a sport rating of 0
							</p>
							<p>2. This will update any existing riders with the new data</p>
							<p>
								- This will include updating the team history with the latest
								team found in the file
							</p>
							<p>
								3. Set any riders not found in this file for the series and
								sport to inactive
							</p>
						</Card.Text>
						<Button variant="success" onClick={handleUpdateRidersFromFile}>
							Upload UCI File
						</Button>
						<Button
							variant="outline-dark"
							className="ms-2"
							onClick={handleDeleteJuniorRiders}
						>
							Delete Junior Riders
						</Button>
					</Card.Body>
				</Card>
			</Container>
		</AdminLayout>
	);
};

export default AdminRidersPage;
